<template>
  <div>
    <el-container style="height:100vh; border: 1px solid #eee">
      <el-aside width="200px;height:100vh;">
        <div>
          <LabelHeader msg="菜单分类"></LabelHeader>
          <div class="buttons">
            <el-button @click="expandAll" size="mini" type="primary" style="width: 40%">展开</el-button>
            <el-button @click="foldAll" size="mini" type="warning" style="width: 40%">收起</el-button>
          </div>
          <el-tree
                  :props="treeProps"
                  :highlight-current="true"
                  :default-expand-all="expandAlls"
                  :data="dataTree"
                  ref="menu"
                  v-if="elTrees"
                  node-key="id"
                  @node-click="go"
                  :expand-on-click-node="false"
          ></el-tree>
        </div>
      </el-aside>

      <el-main style="padding: 0px 5px;">
        <div>
          <LabelHeader msg="菜单管理"></LabelHeader>

          <div style="padding-left: 20px">
            <el-form class="searchForm" :inline="true">
              <el-form-item label="名称：">
                <el-input size="small" style="width: 200px" class="ML-10" type="text" v-model="menuKey" placeholder="输入业务名称" />
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="list()" icon="el-icon-search" size="mini">查询</el-button>
              </el-form-item>
            </el-form>
          </div>
          <LabelHeader msg="查询结果"></LabelHeader>
          <div class="buttonBox">
            <el-button type="primary" size="mini" icon="el-icon-circle-plus-outline" @click="openCreate">新增</el-button>
            <el-button type="warning" @click="openEditDialog" size="mini"><i class="el-icon-edit"></i>修改</el-button>
            <el-button type="danger" size="mini" icon="el-icon-delete" @click="remove()">删除</el-button>
          </div>
          <div class="contentBox">
            <el-table
                    ref="table"
                    v-loading="refreshing"
                    :data="dataGrid"
                    max-height="540"
                    :header-cell-style="{ background: '#f5f7fa', color: '#606266' }"
                    stripe
                    border
                    show-checkbox
                    @selection-change="handleSelectionChange"
            >
              <el-table-column type="selection" align="center"></el-table-column>
              <el-table-column label="图标" min-width="220">
                <template slot-scope="scope">
                  <i :class="scope.row.icon"></i><span v-show="scope.row.icon">({{ scope.row.icon }})</span>
                </template>
              </el-table-column>
              <el-table-column prop="name" label="名称" min-width="200"></el-table-column>
              <el-table-column prop="url" label="地址" min-width="250"></el-table-column>
              <el-table-column prop="orderNum" label="顺序" min-width="80"></el-table-column>
              <el-table-column prop="target" label="打开方式" min-width="110"></el-table-column>
              <el-table-column label="状态" min-width="80">
                <template slot-scope="scope">
                  <div v-for="temp of Ary" :key="temp.id">
                    <span v-if="temp.key === scope.row.enable">{{ temp.title }}</span>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="paginationBox">
            <el-pagination
                    layout="total, sizes, prev, pager, next, jumper"
                    :page-sizes="[10, 20, 50, 100]"
                    :total="pagination.total"
                    @size-change="sizeChange"
                    @current-change="currentChange"
                    :page-size="pagination.pageSize"
            ></el-pagination>
            <el-button class="refreshBtn" circle @click="list">
              <i :class="refreshing ? 'el-icon-refresh refAnimation' : 'el-icon-refresh'"></i>
            </el-button>
          </div>

          <el-dialog v-dialogDrag :visible.sync="openName"
                  v-if="openName" :modal="false" :title="byId ? '编辑菜单' : '新增菜单'" :close-on-click-modal="false">
            <Edit :params="editParam" @close="close" @success="success"></Edit>
          </el-dialog>
        </div>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import Edit from './edit';
import LabelHeader from "../../components/LabelHeader";
export default {
  data() {
    return {
      treeProps: {//el-tree默认取数据中哪个字段
        children: 'children',
        label: 'name'
      },
      currentPid:'',
      dataTree: [],
      dataGrid:[],
      homeData: [{ title: '菜单管理' }],
      Ary: [
        { key: 'TRUE', title: '显示' },
        { key: 'FALSE', title: '隐藏' }
      ],
      openName: false,
      refreshing: false,
      menuKey: null,
      menuId: null,
      pagination: {
        pageNo: 1,
        pageSize: 10,
        total: 0
      },
      byId: null,
      param: {
        keyName: 'id',
        parentName: 'pid',
        titleName: 'name',
        dataMode: 'tree',
        treeIcon: 'icon',
        datas: []
      },
      editParam: {},
      multipleSelection: [],//选中的行
      elTrees: true,
      expandAlls: false,
      treeData: []
    };
  },
  components: {
    Edit,LabelHeader
  },
  // 页面加载获取数据
  mounted() {
    this.tree();
  },
  methods: {
    openEditDialog() {
      if (elKit.checkSelect(this.multipleSelection)) {
        this.dialogTitle = '编辑字典';
        this.editParam.id = this.rows[0].id;
        this.editParam.tree = this.treeData;
        this.openName = true;
      }
    },
    expandAll() {
      this.elTrees = false;
      this.expandAlls = true;
      this.$nextTick(() => {
        this.elTrees = true;
      });
    },
    foldAll() {
      this.elTrees = false;
      this.expandAlls = false;
      this.$nextTick(() => {
        this.elTrees = true;
      });
    },
    handleSelectionChange(rows) {
      this.multipleSelection = rows;
    },
    openCreate() {
      this.openName = true;
      this.editParam.id = null;
    },
    openEdit(id) {
      this.openName = true;
      this.editParam.id = id;
      this.editParam.tree = this.treeData;
    },
    sizeChange(size) {
      this.pagination.pageSize = size;
      this.list();
    },
    currentChange(pageNo) {
      this.pagination.pageNo = pageNo;
      this.list();
    },
    tree() {
      httpKit.post($api_eap.menu.tree).then(res => {
        if (res.data.code === '200') {
          if (res.data.data.length > 0) {
            this.dataTree = res.data.data;
            this.menuId = res.data.data[0].id;
            this.editParam.teamName = res.data.data[0].name;
            this.editParam.teamId = res.data.data[0].id;
            this.list();
          }
        }
      });
    },
    close() {
      this.openName = false;
    },
    success() {
      this.openName = false;
      this.tree();
    },
    go(item) {
      console.log(item.id);
      this.currentPid=item.id;


      this.menuId = item.id;
      this.editParam.teamName = item.name;
      this.editParam.teamId = item.id;
      this.pagination.pageNo = 1;
      this.pagination.pageSize = 10;
      this.list(item.id);
    },
    list(pid) {
      this.pagination.teamId = this.menuId;
      this.pagination.name = this.menuKey;
      this.refreshing = true;
      httpKit.post($api_eap.menu.list,{"pid":pid}).then(res => {
        this.refreshing = false;
        if (res.data.code === '200') {
          this.dataGrid = res.data.data;
          this.pagination.total = res.data.totalItems;
        } else {
          if (res.data.code === '500') {
            this.dataGrid = [];
          }
        }
      });
    },
    refresh() {
      this.tree();
      this.list();
    },
    remove() {
      if (this.multipleSelection.length > 0){
        const idAry = [];
        for (let key in this.multipleSelection){
          idAry.push(this.multipleSelection[key].id);
        }
        let ids = idAry.join(",");
        httpKit.post($api_eap.menu.delete,{"ids":ids}).then(res => {
          if (res.data.code === '200') {
            this.$message.success('删除成功');
          } else if (res.data.code === '500') {

          }
        });
      }else{
        this.$message.warning('请至少选中一条数据');
      }
    }
  }
};
</script>
<style lang="css" scoped>
.el-tree-node .is-current > .el-tree-node__content {
  background-color: #2f8dfb !important;
  color: white;
}
.left {
  max-height: calc(100vh - 230px);
  overflow-y: auto;
}
</style>
